export const basePath = '/settings/trackers'

const routes = {
  root: basePath,
  createTracker: (): string => `${basePath}/create`,
  editTracker: (uid: string): string => `${basePath}/edit/${uid}`,
}

export default routes
